// extracted by mini-css-extract-plugin
export default {"root":"daily_root__5UHw8","table":"daily_table__4Inq+","textLeft":"daily_textLeft__NTp89"};